module.exports = __webpack_public_path__ + "statics/img/cate10-4@2x.7ca8da9c.png";